import React from "react"
import { motion, AnimatePresence } from "framer-motion"
import { wrap } from "@popmotion/popcorn"

import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image/withIEPolyfill"
import browser from 'browser-detect'
import BackgroundImage from 'gatsby-background-image'
import { Link } from "@components/Link"
import { Pc, Sp } from "@hooks/useMediaQuery"
// import { useStores } from "@hooks/useStores"
import { useURL } from "@hooks/useURL"

import css from "@css/components/blocks/IndexHero.module.styl"


const variants = {
    enter: ({page, imageIndex}) => {
      return {
        // x: direction > 0 ? 1000 : -1000,
        // opacity: 0,
        // zIndex: 0
        top: page === imageIndex ? 100 : 0,
      };
    },
    center: {
    //   zIndex: 2,
    //   x: 0,
    //   opacity: 1
    },
    exit: ({page, imageIndex}) => {
        console.log(page, imageIndex)
      return {
        // zIndex: 0,
        // x: direction < 0 ? 1000 : -1000,
        // opacity: 0,
        top: page === imageIndex ? 100 : 0,
      };
    }
  };
const swipeConfidenceThreshold = 10000
const swipePower = (offset, velocity) => {
    return Math.abs(offset) * velocity;
}

const Device = ({q}) => {
    const [[page, direction], setPage] = React.useState([0, 0]);
    // const images = [
    //     q.deviceFront01.publicURL,
    //     q.deviceFront02.publicURL,
    //     q.deviceFront03.publicURL
    // ]
    const images = [
        q.deviceFront01.childImageSharp.fluid,
        q.deviceFront02.childImageSharp.fluid,
        q.deviceFront03.childImageSharp.fluid,
    ]
    const imageIndex = wrap(0, images.length, page)
    const paginate = (newDirection) => {
        setPage([page + newDirection, newDirection]);
    }
    React.useEffect(()=>{
        let id = setTimeout(()=>{
            if( page < images.length - 1 ){
                setPage([page+1,0])
            } else {
                setPage([0,0])
            }
        }, 3000)
    },[page])
    
    return(
        <div className={css.front}>
            <div className={css.base} style={{zIndex: -1}}>
                <Image fluid={q.deviceFront.childImageSharp.fluid} loading='eager' placeholderStyle={{ visibility: "hidden" }}/>
            </div>
            <div className={css.images}>
                    { images.map( ( fluid , i ) => {
                        return(
                            <div className={css.item} key={i} style={{
                                opacity: imageIndex !== i ? 0 : 1,
                                zIndex: imageIndex !== i ? 0 : 1,
                            }}>
                                {/* <Image fluid={fluid} loading='eager' fadeIn={false} /> */}
                                <Image fluid={fluid} loading='eager' placeholderStyle={{ visibility: "hidden" }}/>
                            </div>
                        )
                    }) }
            </div>
        </div>
    )
}

export default function IndexHero()
{
    const q = useStaticQuery(graphql`
        query {
            title: file(relativePath: { eq: "Hero__img__title.svg" }) {
                publicURL
            }
            deviceFront: file(relativePath: { eq: "Hero__img__device-front@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 320) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            deviceFront01: file(relativePath: { eq: "Sct04__img__device-1@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 320) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            deviceFront02: file(relativePath: { eq: "Sct04__img__device-2@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 320) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            deviceFront03: file(relativePath: { eq: "Sct04__img__device-3@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 320) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            deviceBack: file(relativePath: { eq: "Hero__img__device-back@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 320) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            bg: file(relativePath: { eq: "Hero__img__bg@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 1440) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            titleSp: file(relativePath: { eq: "SpHero__img__title.svg" }) {
                publicURL
            }
            logoSp: file(relativePath: { eq: "SpHero__img__logo.svg" }) {
                publicURL
            }
        }
    `)

    const urls = useURL()

    return pug`
        div(className=${css.container})
            // BackgroundImage(fluid=${q.bg.childImageSharp.fluid})
            Pc
                div(className=${css.inner})
                    div(className=${css.devices})
                        Device(q=${q})
                        div(className=${css.back})
                            Image(fluid=${q.deviceBack.childImageSharp.fluid} loading='auto')
                    h1(className=${css.title})
                        img(src=${q.title.publicURL} alt="#すご写編集 カメラがすごい arrows 5G F-51A × Adobe Photoshop Express")
            Sp
                div(className=${css.inner})
                    h1(className=${css.title})
                        img(src=${q.titleSp.publicURL} alt="#すご写編集 カメラがすごい")
                    div(className=${css.devices})
                        Device(q=${q})
                        div(className=${css.back})
                            Image(fluid=${q.deviceBack.childImageSharp.fluid} loading='auto')
                    div(className=${css.logo})
                        img(src=${q.logoSp.publicURL} alt="arrows 5G F-51A × Adobe Photoshop Express")

    `
}